import style from '../listaReceitaBrutaCalculada.module.scss';
import { useState } from 'react';
import {
  INCMReceitaBrutaCalculadaPrecoCorrente,
  INCMReceitaBrutaCalculadaValorReferencia,
} from '../../../../../../../../../../../../interfaces/IReceitaBrutaCalculada';
import ComponenteNCM from '../../../../../../componenteNCM/componenteNCM';
import { ETipoOperacao } from '../../../../../../../../../../../../enums/ETipoOperacao';
import { EMetodoReceitaBrutaCalculada } from '../../../../../../../../../../../../enums/EMetodoBaseCalculo';

interface IListaReceitaBrutaCalculadaItemProps {
  receitaBrutaCalculada: INCMReceitaBrutaCalculadaPrecoCorrente[] | INCMReceitaBrutaCalculadaValorReferencia[];
  type: EMetodoReceitaBrutaCalculada;
}

const ListaReceitaBrutaCalculadaItem = ({ receitaBrutaCalculada, type }: IListaReceitaBrutaCalculadaItemProps) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  return (
    <>
      <div
        data-testid='accordion-ncm'
        className={style.accordion}
        onClick={() => setIsAccordionOpen(!isAccordionOpen)}
        onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
      >
        <div className={style.leftContainer}>
          <span className={style.iconArrow}>
            {!isAccordionOpen ? (
              <i className={`fas fa-chevron-down fa-sm`} />
            ) : (
              <i className={`fas fa-chevron-up fa-sm`} />
            )}
          </span>
          <div className={style.title} data-testid='titulo-ncm'>
            {type === EMetodoReceitaBrutaCalculada.PRECO_CORRENTE ? 'Preço Corrente' : 'Valor Referência'}
          </div>
        </div>
        <div className={style.rightContainer} />
      </div>
      {isAccordionOpen && (
        <div className={style.accordionContent}>
          <ComponenteNCM
            isEdicaoNcm={false}
            isReadOnly={true}
            ncmListaData={receitaBrutaCalculada}
            type={ETipoOperacao.RECEITA_BRUTA_CALCULADA}
          />
        </div>
      )}
    </>
  );
};

export default ListaReceitaBrutaCalculadaItem;
